window.BILLINGURL = process.env.REACT_APP_BILLINGURL;
window.STRIPEKEY = process.env.REACT_APP_STRIPEKEY;
window.MODE = process.env.REACT_APP_MODE;